import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex flex-col footer-container md:px-25 lg:flex-row lg:justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "footer__box sm:mt-8"
}
const _hoisted_3 = { class: "footer__box__content" }
const _hoisted_4 = { class: "flex flex-col mt-10" }
const _hoisted_5 = { class: "footer__box" }
const _hoisted_6 = { class: "footer__box__content" }
const _hoisted_7 = {
  key: 1,
  class: "footer__box"
}
const _hoisted_8 = { class: "footer__box__content" }
const _hoisted_9 = { class: "flex flex-col mt-10" }
const _hoisted_10 = { class: "footer__box md:mt-32 lg:mt-0" }
const _hoisted_11 = { class: "footer__box__content" }
const _hoisted_12 = { class: "flex w-full sm:flex-col sm:items-center md:justify-between md:items-center" }
const _hoisted_13 = { class: "flex h-full sm:w-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sm:hidden" }, "/", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", { class: "md:hidden" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactHeader = _resolveComponent("ContactHeader")!
  const _component_EmailSubscription = _resolveComponent("EmailSubscription")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SocialMediaButton = _resolveComponent("SocialMediaButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isContactPage)
      ? (_openBlock(), _createBlock(_component_ContactHeader, {
          key: 0,
          class: "my-24 md:my-48",
          heading: _ctx.cms.heading,
          label: _ctx.cms.contact_us_label,
          route: _ctx.Route.Contact
        }, null, 8, ["heading", "label", "route"]))
      : _createCommentVNode("", true),
    (_ctx.region === _ctx.Region.CN)
      ? (_openBlock(), _createBlock(_component_EmailSubscription, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Container, {
      fluid: "",
      class: "mt-24 md:mt-32 lg:mt-48 sm:pb-24 font-body"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.region === _ctx.Region.CN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_Heading, {
                    tag: "h3",
                    class: "overflow-hidden",
                    innerHTML: 'Our expertise'
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (i, index) => {
                      return (_openBlock(), _createBlock(_component_Anchor, {
                        key: index,
                        bold: false,
                        smaller: "",
                        route: { name: _ctx.Route.Services, params: { slug: i.slug } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(i.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["route"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Heading, {
                tag: "h3",
                class: "overflow-hidden",
                innerHTML: _ctx.cms.sub_heading_1
              }, null, 8, ["innerHTML"]),
              _createVNode(_component_Paragraph, {
                class: "pr-10 footer__box__content__para",
                smaller: "",
                innerHTML: _ctx.cms.sub_paragraph_1
              }, null, 8, ["innerHTML"]),
              (_ctx.region === _ctx.Region.CN)
                ? (_openBlock(), _createBlock(_component_Anchor, {
                    key: 0,
                    class: "mt-7",
                    route: _ctx.Route.WhatWeDo,
                    smaller: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Learn more ")
                    ]),
                    _: 1
                  }, 8, ["route"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.region === _ctx.Region.CN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Heading, {
                    tag: "h3",
                    class: "overflow-hidden",
                    innerHTML: 'Case studies'
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseStudies, (i, index) => {
                      return (_openBlock(), _createBlock(_component_Anchor, {
                        key: index,
                        class: "!text-sm normal-font-important",
                        smaller: "",
                        route: { name: _ctx.Route.CaseStudy, params: { slug: i.slug } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(i.client_name) + " - " + _toDisplayString(i.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["route"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Heading, {
                tag: "h3",
                class: "overflow-hidden",
                innerHTML: _ctx.cms.sub_heading_3
              }, null, 8, ["innerHTML"]),
              _createVNode(_component_Paragraph, {
                class: "footer__box__content__para",
                smaller: "",
                innerHTML: _ctx.cms.sub_paragraph_3
              }, null, 8, ["innerHTML"]),
              _createElementVNode("div", null, [
                _createVNode(_component_Anchor, {
                  class: "mt-7",
                  "mail-to": "",
                  route: _ctx.cms.email,
                  smaller: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.cms.email), 1)
                  ]),
                  _: 1
                }, 8, ["route"])
              ]),
              _createVNode(_component_Button, {
                class: "contact-button mt-14",
                route: _ctx.Route.Contact
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Contact us → ")
                ]),
                _: 1
              }, 8, ["route"])
            ])
          ])
        ]),
        _createVNode(_component_Grid, { fluid: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              class: "footer__social",
              container: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMedia, (social, index) => {
                      return (_openBlock(), _createBlock(_component_SocialMediaButton, _mergeProps({ key: index }, social, {
                        class: "footer__social__icon",
                        large: ""
                      }), null, 16))
                    }), 128))
                  ]),
                  _createVNode(_component_Paragraph, {
                    smaller: "",
                    class: "text-gray-300 text-2xs md:text-xs sm:pt-12 sm:text-center md:mr-14"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Digital Creative Asia 墨山网络科技（上海）有限公司 "),
                      _hoisted_14,
                      _hoisted_15,
                      _createTextVNode(" 沪ICP备19005446号-1 ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}